import React, { useContext } from 'react';
import { Icon } from 'semantic-ui-react';

import { Contact as DylContact, LinkedAccount, Table, TableLoader, USER_PERMISSIONS } from 'dyl-components';
import { PhoneUtil, StringUtils } from 'utils';
import { Link, useParams } from 'react-router-dom';
import { connect, useDispatch, useSelector } from 'react-redux';

import InfluenceField from 'pages/Account/InfluenceField';

import { ContactContext } from 'shared/context/ContactProvider';
import ContactConversionControls from 'shared/ContactConversionControls';
import { ActivityPopup } from 'shared/forms/NewActivity';
import TextIcon from 'shared/TextIcon';
import RestrictedView from 'shared/RestrictedView';

const mapStateToProps = state => ({
    contactBeingUpdated: state.contact.contactBeingUpdated,
})

export const Contact = connect(mapStateToProps)(({
    first_name,
    last_name,
    id,
    email,
    phone,
    location,
    influence,
    module_summary,
    job_title,

    pinned,
    primary,

    onEdit,
    onCancelEdit,
    contactBeingEdited,
    contactBeingUpdated,
    account,
    contact,
    onSelectContactForConversion,
    refresh
}) => {
    const name = `${first_name} ${last_name}`;

    const dispatch = useDispatch();

    const { account_id } = useParams();

    const { officeViewCreds, hasEmailIntegrations } = useSelector((state) => ({
        officeViewCreds: state.officeView.creds,
        hasEmailIntegrations: state.oauth_integrations?.integrations?.length > 0,
    }));

    const isUpdating = contactBeingUpdated === id;
    const isPhoneSystemSupported =
        PhoneUtil.isPhoneSystemSupported(officeViewCreds);

    const { onOpenModal } = useContext(ContactContext);

    const onClickToDial = () => {
        PhoneUtil.C2D({ payload: { contact_id: id, destination: phone?.phone, account_id: Number(account_id) }, dispatch })
    }

    return (
        !isUpdating ? (
            <Table.Row>
                <Table.Cell>
                    {pinned && <Icon color='primary' link className='fas thumbtack' />}
                    {primary && <Icon color='primary' className='fas fa-address-book' />}
                </Table.Cell>
                <Table.Cell>
                    <DylContact
                        phone={phone?.phone}
                        email={email?.email}
                        account_id={account_id}
                        contact_id={id}
                        isPhoneSystemSupported={isPhoneSystemSupported}
                        hasEmailIntegrations={hasEmailIntegrations}
                        onCallClick={onClickToDial}
                        onTextClick={() => onOpenModal("text", { id, first_name, last_name, phone, email })}
                        onEmailClick={() => {
                            onOpenModal('email', id);
                        }}
                        onNoteClick={() => {
                            onOpenModal('note', { id, first_name, last_name });
                        }}
                        ActivityPopup={ActivityPopup}
                        TextIcon={TextIcon}
                        callActivityProps={{
                            hideActivitySelection: true,
                            account: {
                                id: account?.id,
                            }
                        }}
                        emailActivityProps={{
                            readTimeline: () => { },
                            contact,
                            isContact: true,
                            emailOnly: true
                        }}
                        leftSideContent={<LinkedAccount
                            maxWidth={'9em'}
                            account={name}
                            subtitle={job_title}
                            linkToAccount={
                                <RestrictedView type="link" userPermission={USER_PERMISSIONS.CONTACTS_VIEW} userRestrict assignmentIds={[(contact?.assignees?.owner_id || 0), (contact?.assignees?.coowner_id || 0)]}>
                                    <Link target={'_blank'} to={`/contact/${id}`}>{name}</Link>
                                </RestrictedView>
                            }
                        />}
                    />
                </Table.Cell>
                <Table.Cell>
                    <InfluenceField
                        account_id={account_id}
                        contactBeingEdited={contactBeingEdited}
                        id={id}
                        influence={influence}
                        onCancelEdit={onCancelEdit}
                        onEdit={onEdit}
                        refresh={refresh}
                        recordType="account"
                        assignees={account?.assignees}
                    />
                </Table.Cell>
                <Table.Cell>{Object.keys(module_summary).length > 1 ? `${StringUtils.capitalize(module_summary.account_stage)}-${module_summary?.pipeline_stage_name}` : ''}</Table.Cell>
                <Table.Cell>
                    <ContactConversionControls
                        account_id={Number(account_id)}
                        account_stage={module_summary?.account_stage || "contact"}
                        contactName={name}
                        contact_id={id}
                        linkedAccountIsACustomer={account.customer}
                        linkedAccountName={account.name}
                        linkedAccountPrimaryContact={account.primary_contact.id}
                        refresh={refresh}
                        pipeline_id={module_summary?.pipeline_id}
                        master_source={module_summary?.master_source}
                        secondary_source={module_summary?.secondary_source}
                        location={location}
                        phone={phone}
                        email={email}
                        contact={contact?.assignees}
                        onSelectForConversion={onSelectContactForConversion}
                    />
                </Table.Cell>
            </Table.Row>
        ) : (
            <TableLoader isLoading colspan={5} />
        )
    );
})
